import axios from "axios";

class ProofOfMembershipService {
  verifyMembership(user) {
    return axios
      .post(localStorage.getItem("pom-api-url") + "Send", {
        email: user.membershipProofEmail,
        organizationnumber: user.organizationnumber
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      });
  }
  cancel() {
    localStorage.removeItem("user");
  }
}

export default new ProofOfMembershipService();
